import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
import { ErroBoundary } from "./app/ErroBoundary.tsx";
import { iniciarPwa } from "./lib/pwaUpdate.ts";
import "./styles/global.css";

// Registra o service worker e passa a checar atualizações (aviso de nova versão).
iniciarPwa();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Elemento #root não encontrado");
}

createRoot(container).render(
  <StrictMode>
    <ErroBoundary>
      <App />
    </ErroBoundary>
  </StrictMode>,
);
